/* Sevine Dumont · homepage (H1-H9). Vanilla JS, geen libraries.
   - fade-in-up (Fleuron)            [.sd-hm-reveal]
   - H2b: 2 foto's per kaart met pijltjes (Fleuron product-block)
   - H3b: slider met pijlen en teller "1/3", scroll-indicator op mobiel, foto-bolletjes per kaart (Isabel Bernard)
   - H5b/H9: video's spelen gedempt zodra ze in beeld zijn; H9 geluidsknop en pijlen
   - wishlist-hartje (localStorage 'sd-wishlist', dezelfde sleutel als de collectiekaart) */
(function () {
  'use strict';
  if (window.sdHm) return; /* script staat in meerdere secties: maar één keer draaien */
  window.sdHm = true;
  var doc = document.documentElement;
  doc.classList.add('sd-hm-anim');

  function each(sel, root, fn) { Array.prototype.forEach.call((root || document).querySelectorAll(sel), fn); }
  var hasIO = 'IntersectionObserver' in window;

  /* ---------- reveal ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.sd-hm-reveal:not(.is-in)');
    if (!hasIO) { each('.sd-hm-reveal', root, function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.1 });
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  /* ---------- H2b product-block slides ---------- */
  function initProductBlocks(root) {
    each('[data-sd-hm-pb]', root, function (card) {
      if (card.dataset.ready) return; card.dataset.ready = '1';
      var slides = card.querySelectorAll('.sd-hm-pb__slide');
      if (slides.length < 2) return;
      var idx = 0, hover = false;
      function show(i) {
        idx = (i + slides.length) % slides.length;
        Array.prototype.forEach.call(slides, function (s, k) { s.classList.toggle('is-active', k === idx); });
      }
      card.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) { hover = true; show(1); } });
      card.addEventListener('mouseleave', function () { if (hover) { hover = false; show(0); } });
      each('[data-sd-hm-pb-prev]', card, function (b) { b.addEventListener('click', function (e) { e.preventDefault(); show(idx - 1); }); });
      each('[data-sd-hm-pb-next]', card, function (b) { b.addEventListener('click', function (e) { e.preventDefault(); show(idx + 1); }); });
    });
  }

  /* ---------- generic scroll slider (H3b, H9) ---------- */
  function initSlider(wrap) {
    if (wrap.dataset.ready) return; wrap.dataset.ready = '1';
    var track = wrap.querySelector('[data-sd-hm-track]');
    if (!track) return;
    var prev = wrap.querySelector('[data-sd-hm-prev]');
    var next = wrap.querySelector('[data-sd-hm-next]');
    var count = wrap.querySelector('[data-sd-hm-count]');
    var thumb = wrap.querySelector('[data-sd-hm-thumb]');
    function pageW() {
      var first = track.children[0];
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var per = Math.max(1, Math.floor((track.clientWidth + gap) / (first.getBoundingClientRect().width + gap)));
      return per * (first.getBoundingClientRect().width + gap);
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var pw = pageW();
      var pages = Math.max(1, Math.ceil(max / pw - 0.05) + 1);
      var cur = max <= 0 ? 1 : Math.min(pages, Math.round(track.scrollLeft / pw) + 1);
      if (track.scrollLeft >= max - 2) cur = pages;
      if (count) count.textContent = cur + '/' + pages;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      if (thumb) {
        var ratio = track.clientWidth / track.scrollWidth;
        var wPct = Math.max(10, ratio * 100);
        thumb.style.width = wPct + '%';
        thumb.style.left = (max > 0 ? (track.scrollLeft / max) * (100 - wPct) : 0) + '%';
      }
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -pageW(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: pageW(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- IB card: photo dots on mobile + wishlist ---------- */
  function initCards(root) {
    each('[data-sd-ib-swipe]', root, function (sw) {
      if (sw.dataset.ready) return; sw.dataset.ready = '1';
      var card = sw.closest('.sd-ib-card') || sw.parentNode;
      var dots = card.querySelectorAll('[data-sd-ib-dot]');
      if (!dots.length) return;
      sw.addEventListener('scroll', function () {
        var i = Math.round(sw.scrollLeft / Math.max(1, sw.clientWidth));
        Array.prototype.forEach.call(dots, function (d, k) { d.classList.toggle('is-active', k === i); });
      }, { passive: true });
      Array.prototype.forEach.call(dots, function (d) {
        d.addEventListener('click', function (e) {
          e.preventDefault();
          var k = parseInt(d.getAttribute('data-sd-ib-dot'), 10);
          Array.prototype.forEach.call(dots, function (x, j) { x.classList.toggle('is-active', j === k); });
          sw.scrollTo({ left: k * sw.clientWidth, behavior: 'smooth' });
        });
      });
    });
    var key = 'sd-wishlist';
    function read() { try { return JSON.parse(window.localStorage.getItem(key) || '[]'); } catch (e) { return []; } }
    function write(list) { try { window.localStorage.setItem(key, JSON.stringify(list)); } catch (e) { /* storage blocked */ } }
    each('[data-sd-ib-wish]', root, function (btn) {
      if (btn.dataset.ready) return; btn.dataset.ready = '1';
      var h = btn.getAttribute('data-sd-ib-wish');
      btn.setAttribute('aria-pressed', read().indexOf(h) > -1 ? 'true' : 'false');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var list = read(), i = list.indexOf(h);
        if (i > -1) list.splice(i, 1); else list.push(h);
        write(list);
        btn.setAttribute('aria-pressed', i > -1 ? 'false' : 'true');
      });
    });
  }

  /* ---------- videos: play when visible ---------- */
  function initVideos(root) {
    var vids = (root || document).querySelectorAll('video[data-sd-hm-video]');
    if (!vids.length) return;
    function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    if (!hasIO) { Array.prototype.forEach.call(vids, play); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (v.preload === 'none') v.preload = 'metadata';
          play(v);
        } else if (!v.paused) { v.pause(); }
      });
    }, { rootMargin: '200px 0px', threshold: 0.01 });
    Array.prototype.forEach.call(vids, function (v) { if (!v.dataset.ready) { v.dataset.ready = '1'; io.observe(v); } });
    each('[data-sd-hm-mute]', root, function (b) {
      if (b.dataset.ready) return; b.dataset.ready = '1';
      b.addEventListener('click', function () {
        var v = b.parentNode.querySelector('video');
        if (!v) return;
        v.muted = !v.muted;
        b.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
        if (!v.muted) play(v);
      });
    });
  }

  function init(root) {
    initReveal(root);
    initProductBlocks(root);
    each('[data-sd-hm-slider]', root, initSlider);
    initCards(root);
    initVideos(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
